export const GET_POLLS = 'GET_POLLS'
export const RESET_POLLS = 'RESET_POLLS'
export const SET_POLLS = 'SET_POLLS'
export const RECEIVED_POLLS_INFINITE_LOADING = 'RECEIVED_POLLS_INFINITE_LOADING'

export const GET_PATH_IMAGE = 'GET_PATH_IMAGE'
export const SET_PATH_IMAGE = 'SET_PATH_IMAGE'
export const RECEIVED_PATH_IMAGE = 'RECEIVED_PATH_IMAGE'

export const GET_OLD_POLLS = 'GET_OLD_POLLS'
export const RESET_OLD_POLLS = 'RESET_OLD_POLLS'
export const SET_OLD_POLLS = 'SET_OLD_POLLS'
export const RECEIVED_OLD_POLLS_INFINITE_LOADING = 'RECEIVED_OLD_POLLS_INFINITE_LOADING'

export const SAVE_POLL = 'SAVE_POLL'
export const SAVE_POLL_CHOICE = 'SAVE_POLL_CHOICE'
export const SAVE_SELECT_CHOICE = 'SAVE_SELECT_CHOICE'

export const POST_POLL = 'POST_POLL'
export const POST_CHOICE = 'POST_CHOICE'
export const POST_SELECT_CHOICE = 'POST_SELECT_CHOICE'
export const DELETE_CHOICE = 'DELETE_CHOICE'



// WEBPACK FOOTER //
// ./src/store/modules/poll/mutation-types.js